"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.clear = clear;
exports.get = get;

/**
 * @module ol/proj/projections
 */

/**
 * @type {Object<string, import("./Projection.js").default>}
 */
var cache = {};
/**
 * Clear the projections cache.
 */

function clear() {
  cache = {};
}
/**
 * Get a cached projection by code.
 * @param {string} code The code for the projection.
 * @return {import("./Projection.js").default} The projection (if cached).
 */


function get(code) {
  return cache[code] || cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
/**
 * Add a projection to the cache.
 * @param {string} code The projection code.
 * @param {import("./Projection.js").default} projection The projection to cache.
 */


function add(code, projection) {
  cache[code] = projection;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7Ozs7QUFJQTs7O0FBR0EsSUFBSUEsS0FBSyxHQUFHLEVBQVo7QUFFQTs7OztBQUdNLFNBQVVDLEtBQVYsR0FBZTtFQUNuQkQsS0FBSyxHQUFHLEVBQVI7QUFDRDtBQUVEOzs7Ozs7O0FBS00sU0FBVUUsR0FBVixDQUFjQyxJQUFkLEVBQWtCO0VBQ3RCLE9BQ0VILEtBQUssQ0FBQ0csSUFBRCxDQUFMLElBQ0FILEtBQUssQ0FBQ0csSUFBSSxDQUFDQyxPQUFMLENBQWEsd0NBQWIsRUFBdUQsU0FBdkQsQ0FBRCxDQURMLElBRUEsSUFIRjtBQUtEO0FBRUQ7Ozs7Ozs7QUFLTSxTQUFVQyxHQUFWLENBQWNGLElBQWQsRUFBb0JHLFVBQXBCLEVBQThCO0VBQ2xDTixLQUFLLENBQUNHLElBQUQsQ0FBTCxHQUFjRyxVQUFkO0FBQ0QiLCJuYW1lcyI6WyJjYWNoZSIsImNsZWFyIiwiZ2V0IiwiY29kZSIsInJlcGxhY2UiLCJhZGQiLCJwcm9qZWN0aW9uIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9wcm9qL3Byb2plY3Rpb25zLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19